// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RuleEditor_wrapper__17O1S"};